import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

export class ProfileVue extends Vue {
  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**Открытие страницы с опредленной активной вкладкой */
  set tab(tab) {
    this.$router.replace({ query: { ...this.$route.query, tab } })
  }
  get tab(): string  {
    return this.$route.query.tab
  }

  /**Стор настроек */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get loading() {
    return this.personStore.loading;
  }

  get personInfo() {
    return this.personStore.personInfo;
  }

  setAvatarLoading: boolean = false;

  checkbox: boolean = true;

  dialog: boolean =  false;

  async handleFileUpload() {
    this.setAvatarLoading = true;
    try {
      const file = (this.$refs.file as any).files[0];
      this.personStore.setPersonAvatar(file);
      this.setAvatarLoading = false;
    } catch (e) {
      this.setAvatarLoading = false;
    }
  }

  openEmail() {
    window.location.assign(`mailto:${this.personInfo.Data.CustomFields.VipManagerEmail}`);
  }

  async removeAvatar() {
    this.setAvatarLoading = true;
    this.personStore.removePersonAvatar();
    this.setAvatarLoading = false;
  }
}
